import { createFileRoute, redirect } from '@tanstack/react-router'
import { uniq } from 'lodash/fp'

import { FEATURE_DISCOVER_ADVANCED_FILTERS } from '@/core/constants/features'
import { DiscoverChannelsBody } from '@/discover/components/DiscoverChannelsBody/DiscoverChannelsBody'

export const Route = createFileRoute('/_learning/discover/channels/$channel')({
  beforeLoad: ({ context, params, search }) => {
    if (!context.user?.features.includes(FEATURE_DISCOVER_ADVANCED_FILTERS)) {
      return
    }

    throw redirect({
      replace: true,
      search: {
        ...search,
        channels: uniq([params.channel, ...(search.channels ?? [])]),
      },
      to: '/discover/channels',
    })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { channel } = Route.useParams()

  return <DiscoverChannelsBody channelSlug={channel} />
}
